import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import styled from "styled-components";
import { init, balanceOf, getBalance } from "../../config/provider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import environmentVariables from "../../config/environmentVariables";

const Root = styled.div`
  position: relative;
  height: 600px;
  overflow: hidden;
  width: 90%;
  border: 1px solid #151a1c;
  border-radius: 15px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1600px) {
    height: 500px;
    width: 90%;
  }
  @media (max-width: 1300px) {
    height: 400px;
    width: 90%;
  }
  @media (max-width: 768px) {
    height: 100%;
    width: 90%;
    border-radius: 15px;
  }
`;




const Video = styled.video`
  width: 100%;
  /* filter: grayscale(1); */
  /* opacity: 0.8; */
`;


const HeroSection = ({ allContractDetails, setAllContractDetails }) => {
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails?.address;
      setAddress(address);
    } else {
      setAddress("");
    }
  }, [allContractDetails]);


  return (
    <>
      <Root>
        <Video muted autoPlay={"autoplay"} preLoad="auto" loop>
          <source
            src={`${environmentVariables?.cdnUrl}hero3.mp4`}
            type="video/mp4"
          />
        </Video>
        
      </Root>
    </>
  );
};

export default HeroSection;
